import {getCheckoutClient} from "../../../config/CheckoutClient";
import {addServerErrors} from "../../../actions/ui";
import {fetchReservation, reservationCreated, setReservationData} from "../../../actions/reservation";
import {setPriceLevels, setProducts, updatePriceLevels, setBundles} from '@/actions/event';
import { isReservationContentFree} from 'checkout/selectors/reservation';
import { triggerTransition } from '@uirouter/redux';
import { setListingItem, getListingItem } from "listing/helpers/storage";
import { setInsurancePolicy } from "checkout/views/insurance/actions/insurance";
import { isKioskMode } from '../../../selectors/ui';
import { serializeToUrl } from '../../../helpers/helpers';

export function setCouponCode(code) {
    return {type: "SET_COUPON_CODE", code};
}

export function setCouponInput(code) {
    return {type: "SET_COUPON_INPUT", code};
}

export function setAutoCouponAmount(autoCouponAmount) {
    return {type: "SET_AUTO_COUPON_AMOUNT", autoCouponAmount};
}

export function setPresaleCode(presaleCode) {
    return {type: "SET_PRESALE_CODE", presaleCode};
}

export function setCouponData(couponData) {
    return {type: "SET_COUPON_DATA", couponData}
}

export function setShowError(showError) {
    return {type: "SET_SHOW_ERROR", showError};
}

export function setShowSuccess(showSuccess) {
    return {type: "SET_SHOW_SUCCESS", showSuccess};
}

export function setShowWarning(showWarning) {
    return {type: "SET_SHOW_WARNING", showWarning};
}

export function setIsPresaleValid(isPresaleValid) {
    return {type: "SET_IS_PRESALE_VALID", isPresaleValid}
}

export function setIsPresaleApplied(isPresaleCodeApplied) {
    return {type: "SET_IS_PRESALE_APPLIED", isPresaleCodeApplied}
}

export function setAccessCode(accessCode) {
    return {type: "SET_ACCESS_CODE", accessCode};
}

export function setIsAccessCodeValid(isAccessCodeValid) {
    return {type: "SET_IS_ACCESS_CODE_VALID", isAccessCodeValid}
}

export function setIsAccessCodeApplied(isAccessCodeApplied) {
    return {type: "SET_IS_ACCESS_CODE_APPLIED", isAccessCodeApplied}
}

export function setShowAccessCodeError(showAccessCodeError) {
    return {type: "SET_SHOW_ACCESS_CODE_ERROR", showAccessCodeError}
}

export function setShowAccessCodeSuccess(showAccessCodeSuccess) {
    return {type: "SET_SHOW_ACCESS_CODE_SUCCESS", showAccessCodeSuccess}
}

export function couponSubmitted(code) {
    return {type: "COUPON_SUBMITTED", code}
}

export function setUnlockedPresaleEvent(id) {
    return {type: "SET_UNLOCKED_PRESALE_EVENT", id};
}

export function setAccessInventory(val) {
    return {type: "SET_ACCESS_INVENTORY", val};
}

const getEventId = state => {
    return (state.event.childEvent) ? state.event.childEvent.event_id : Object.values(state.event.events)[0].event.event_id;
}

export function validateCoupon(code) {
    return (dispatch, getState) => {
        let state = getState();
        dispatch(couponSubmitted(code));
        let payload = serializeToUrl({
            code: code,
            eventId: getEventId(state),
            token: (state.reservation.token !== '') ? state.reservation.token : getListingItem(state.ui.listingSlug, "token")/*localStorage.getItem('token')*/,
            listingId: state.ui.listingId,
        });

        return fetch(state.ui.apiUrl + '/coupon-validation?' + payload, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.isPlCode === true) {
                if (isKioskMode(state)) {//do not allow access coupons for kiosk listings
                    dispatch(setShowError(true));
                } else if (data.valid === true) {
                    if (state.coupon.isAccessCodeApplied === true) {
                        dispatch(setShowAccessCodeError(true));
                    } else {
                        dispatch(setAccessCode(code));
                        dispatch(setIsAccessCodeValid(data.valid));
                        dispatch(submitPriceLevelCoupon(code));
                    }
                } else {
                    dispatch(setShowError(!data.valid));
                }
            } else {
                if (data.valid === true) {
                    dispatch(setCouponCode(code));
                    dispatch(setShowSuccess(data.valid));
                    dispatch(setShowError(!data.valid));
                    dispatch(setCouponInput(""));
                } else {
                    dispatch(setShowError(true));
                }
            }
        }).catch(function(err) {
            dispatch(setShowError(true));
            dispatch(setShowSuccess(false));
        });
    }
}

export function validatePresaleCoupon(reload = null) {
    return (dispatch, getState) => {
        let state = getState();
        let payload = serializeToUrl({
            code: state.coupon.presaleCode,
            eventId: getEventId(state),
            listingId: state.ui.listingId,
        });

        return fetch(state.ui.apiUrl + '/presale-coupon-validation?' + payload, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.valid === true) {
                dispatch(setPriceLevels(data.price_levels));
                if (data.products) dispatch(setProducts(data.products));
                if (data.bundles) dispatch(setBundles(data.bundles));
                dispatch(setPresaleCode(state.coupon.presaleCode));
                dispatch(setIsPresaleValid(data.valid));
                dispatch(setCouponInput(""));
                if (reload !== true) dispatch(submitPresaleCoupon());
            } else {
                dispatch(setShowError(!data.valid));
            }
        }).catch(function(err) {
            dispatch(setShowError(true));
            dispatch(setShowSuccess(false));
        });
    }
}

export function submitCoupon() {
    return (dispatch, getState) => {
        let state = getState();
        let code = state.coupon.code;
        let eventId = getEventId(state);
        var payload = {
            event_id: +eventId,
            reservation_id: state.reservation.id,
            code: code,
            amount: null,
            coupon_type: null,
        };

        return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'coupon-usage', payload, state.reservation.secret).then((result) => {
            dispatch(setShowSuccess(true));
            return dispatch(fetchReservation(state.reservation.token, state.reservation.secret)).then(() => {
                state = getState();
                if(state.insurance.selected !== "" && isReservationContentFree(state)) {
                    dispatch(setInsurancePolicy(""));
                }
                dispatch(setCouponInput(""));
            });
        }).catch((error) => {
            if (error.response.statusCode === 400) {
                dispatch(addServerErrors(error.response.body.errors));
                dispatch(setShowError(true));
                dispatch(setShowSuccess(false));
                return Promise.reject("");
            }
        });
    }
}

export function submitPresaleCoupon() {
    return (dispatch, getState) => {
        let state = getState();
        let eventId = getEventId(state);
        var payload = {
            event_id: +eventId,
            code: state.coupon.presaleCode,
            amount: null,
            coupon_type: null,
            reservation_id: state.reservation.id,
        };

        const resPayload = {
            captureMethod: state.payment.method,
            listingId: state.ui.listingId,
            seller_id: state.event.seller_id,
        }

        return getCheckoutClient(state.ui.apiUrl).createResource('reservations', resPayload, '').then((result) => {
            let secret = result.header['reservation-secret'];
            let token = result.body.data.id;
            setListingItem(state.ui.listingSlug, "secret", secret);
            setListingItem(state.ui.listingSlug, "token", token);
            dispatch(reservationCreated());
            dispatch(setReservationData(secret, result.body.data));

            return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(token, 'presale-coupon-usage', payload, secret).then((result) => {
                dispatch(setIsPresaleApplied(true));
            }).then(() => {
                fetchReservation(token, secret)(dispatch, getState);
                dispatch(setShowError(false));
                dispatch(setShowWarning(false));
                dispatch(setUnlockedPresaleEvent(eventId));
                dispatch(triggerTransition("ticketPicker"));
                dispatch(setCouponInput(""));
            }).catch((error) => {
                if (error.response.statusCode === 400) {
                    dispatch(setPresaleCode(''));
                    dispatch(setIsPresaleValid(false));
                    dispatch(setIsPresaleApplied(false));
                    dispatch(addServerErrors(error.response.body.errors));
                    return Promise.reject("");
                }
            });
        }).catch(e => {
        });
    }
}

export function submitPriceLevelCoupon(code) {
    return (dispatch, getState) => {
        let state = getState();
        let token = state.reservation.token;
        let payload = {
            event_id: getEventId(state),
            code: code,
            coupon_type: 11,
        };

        if (token !== '') {
            return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'pl-coupon-usage', payload, state.reservation.secret).then((result) => {
                dispatch(setIsAccessCodeApplied(true));
                dispatch(getHiddenPriceLevels());
                dispatch(setShowError(false));
                dispatch(setShowWarning(false));
                dispatch(setShowAccessCodeSuccess(true));
                dispatch(triggerTransition("ticketPicker"));
                dispatch(setCouponInput(""));
                return fetchReservation(state.reservation.token, state.reservation.secret)(dispatch, getState);
            }).catch((error) => {
                if (error.response.statusCode === 400) {
                    dispatch(addServerErrors(error.response.body.errors));
                    dispatch(setShowError(true));
                    return Promise.reject("");
                }
            });
        } else {
            const resPayload = {
                captureMethod: state.payment.method,
                listingId: state.ui.listingId,
                seller_id: state.event.seller_id,
            }
            return getCheckoutClient(state.ui.apiUrl).createResource('reservations', resPayload, '').then((result) => {
                let secret = result.header['reservation-secret'];
                let token = result.body.data.id;
                setListingItem(state.ui.listingSlug, "secret", secret);
                setListingItem(state.ui.listingSlug, "token", token);
                dispatch(reservationCreated());
                dispatch(setReservationData(secret, result.body.data));
                dispatch(setCouponInput(""));

                return priceLevelCouponUsage(state, token, payload, secret, dispatch, getState);
            }).catch(e => {
            });
        }
    }
}

function priceLevelCouponUsage(state, token, payload, secret, dispatch, getState) {
    return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(token, 'pl-coupon-usage', payload, secret).then((result) => {
        dispatch(setIsAccessCodeApplied(true));
        dispatch(getHiddenPriceLevels());
        return Promise.resolve(true);
    }).then(() => {
        fetchReservation(token, secret)(dispatch, getState);
        dispatch(setShowError(false));
        dispatch(setShowWarning(false));
        dispatch(setShowAccessCodeSuccess(true));
        dispatch(triggerTransition("ticketPicker"));
    }).catch((error) => {
        if (error.response.statusCode === 400) {
            dispatch(setAccessCode(''));
            dispatch(setIsAccessCodeValid(false));
            dispatch(setIsAccessCodeApplied(false));
            dispatch(addServerErrors(error.response.body.errors));
            return Promise.reject("");
        }
    });
}

/**
 * Updates price levels and custom inventory configuration after submitting an access code
 */
export function getHiddenPriceLevels() {
    return (dispatch, getState) => {
        let state = getState();
        let payload = serializeToUrl({
            code: state.coupon.accessCode,
            eventId: getEventId(state),
            token: (state.reservation.token !== '') ? state.reservation.token : getListingItem(state.ui.listingSlug, "token")/*localStorage.getItem("token")*/
        });

        return fetch(state.ui.apiUrl + '/price-levels-coupon?' + payload, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
        }).then((response) => {
            return response.json();
        }).then((data) => {
            dispatch(updatePriceLevels(data.price_levels));
            if (data.inventory) {
                dispatch(setAccessInventory(data.inventory));
            }
        }).catch(function(err) {
        });
    }
}

// only sets the discount coupon data for now
export function fetchCouponUsage(token, secret) {
    return (dispatch, getState) => {
        let state = getState();
        return getCheckoutClient(state.ui.apiUrl).reservationGetRequest(token, 'coupon-usage', secret).then((result) => {
            if (state.coupon.code !== "" && state.coupon.showSuccess === true) {
                dispatch(setCouponData(getDiscountCoupons(state, result.body.data)));
            }
            return Promise.resolve();
        });
    }
}

export function getDiscountCoupons(state, usedCoupons) {
    let usedDiscountCoupons = [];

    usedCoupons.forEach(usedCoupon => {
        if (usedCoupon['attributes']['coupon_type'] === 2 || usedCoupon['attributes']['coupon_type'] === 7) {
            usedDiscountCoupons.push(usedCoupon.attributes);
        }
    });

    let discountCouponSum = 0;
    usedDiscountCoupons.forEach(discountCoupon => {
        discountCouponSum += discountCoupon.amount;
    });

    if (usedDiscountCoupons.length && state.coupon.code === usedDiscountCoupons[0].code) {
        return {
            amount: discountCouponSum,
            code: usedDiscountCoupons[0].code,
            coupon_name: usedDiscountCoupons[0].coupon_name,
            coupon_offer_id: usedDiscountCoupons[0].coupon_offer_id,
            coupon_type: usedDiscountCoupons[0].coupon_type,
            event_coupon_id: usedDiscountCoupons[0].event_coupon_id,
            event_id: usedDiscountCoupons[0].event_id,
            reservation_id: usedDiscountCoupons[0].reservation_id
        };
    } else {
        return {};
    }
}
